import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { buildApiUrl } from "../config/api";
import { USERS } from "./Home";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  width: "calc(100% - 32px)",
  maxWidth: 440,
};

export default function CancelPage() {
  const { token } = useParams();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [cancelled, setCancelled] = useState(false);
  const [cancelling, setCancelling] = useState(false);

  useEffect(() => {
    fetch(buildApiUrl(`/api/requests/by-token/${token}`))
      .then((res) => {
        if (!res.ok) throw new Error("not found");
        return res.json();
      })
      .then((data) => {
        setBooking(data);
        setLoading(false);
      })
      .catch(() => {
        setNotFound(true);
        setLoading(false);
      });
  }, [token]);

  const handleCancel = async () => {
    setCancelling(true);
    try {
      const res = await fetch(buildApiUrl(`/api/requests/cancel/${token}`), {
        method: "POST",
      });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.error || "Помилка скасування");
      }
      const stored = JSON.parse(localStorage.getItem("kokorin_bookings") || "[]");
      localStorage.setItem(
        "kokorin_bookings",
        JSON.stringify(stored.filter((b) => b.cancelToken !== token))
      );
      setCancelled(true);
      setConfirmOpen(false);
    } catch (err) {
      alert(err.message);
    } finally {
      setCancelling(false);
    }
  };

  const trainerLabel = booking
    ? USERS.find((u) => u.id === booking.trainer)?.label || booking.trainer
    : "";

  const alreadyCancelled = booking?.status === "failed";

  return (
    <div className="App home">
      <div className="top-service-bar">
        <div>Скасування запису</div>
        <div>Онлайн запис на тренування</div>
      </div>

      <div className="cancel-page-card">
        {loading ? (
          <p style={{ padding: "40px 0" }}>Завантаження...</p>
        ) : notFound ? (
          <>
            <div className="cancel-page-icon">❌</div>
            <h2>Запис не знайдено</h2>
            <p>Посилання недійсне або запис вже видалено.</p>
            <a href="/" className="button reserve" style={{ marginTop: 20 }}>
              На головну
            </a>
          </>
        ) : cancelled ? (
          <>
            <div className="cancel-page-icon">✅</div>
            <h2>Запис скасовано</h2>
            <p>Ваш запис успішно скасовано. Слот знову доступний.</p>
            <a href="/" className="button reserve" style={{ marginTop: 20 }}>
              Записатись знову
            </a>
          </>
        ) : alreadyCancelled ? (
          <>
            <div className="cancel-page-icon">ℹ️</div>
            <h2>Вже скасовано</h2>
            <p>Цей запис вже було скасовано раніше.</p>
            <a href="/" className="button reserve" style={{ marginTop: 20 }}>
              На головну
            </a>
          </>
        ) : (
          <>
            <div className="cancel-page-icon">📋</div>
            <h2>Скасування запису</h2>
            <div className="cancel-page-details">
              <div>
                <span>Тренер</span>
                <strong>{trainerLabel}</strong>
              </div>
              <div>
                <span>Дата</span>
                <strong>{booking.date}</strong>
              </div>
              <div>
                <span>Час</span>
                <strong>{booking.time}</strong>
              </div>
              <div>
                <span>Клієнт</span>
                <strong>
                  {booking.name} {booking.surname}
                </strong>
              </div>
            </div>
            <button
              onClick={() => setConfirmOpen(true)}
              className="button cancel-btn"
              style={{ marginTop: 24 }}
            >
              Скасувати запис
            </button>
            <a href="/" className="cancel-page-back">
              Повернутись
            </a>
          </>
        )}
      </div>

      <Modal open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <div className="modal_container">
          <Box sx={modalStyle}>
            <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
              Підтвердження скасування
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Ви впевнені що хочете скасувати запис?
              <br />
              <strong>
                {trainerLabel} • {booking?.date} • {booking?.time}
              </strong>
            </Typography>
            <div style={{ display: "flex", gap: 12 }}>
              <button
                onClick={handleCancel}
                disabled={cancelling}
                className="button cancel-btn"
                style={{ flex: 1 }}
              >
                {cancelling ? "Скасування..." : "Так, скасувати"}
              </button>
              <button
                onClick={() => setConfirmOpen(false)}
                className="button reserve"
                style={{ flex: 1 }}
              >
                Назад
              </button>
            </div>
          </Box>
        </div>
      </Modal>
    </div>
  );
}
